
class NavigationSection {
  constructor(contentfulNode) {
    this.title = contentfulNode?.title;
    this.heroImage = contentfulNode?.heroImage
      ? {
        fluid: contentfulNode?.heroImage?.gatsbyImageData,
        title: contentfulNode?.heroImage?.title
      }
      : null;
    this.featuredContentTagline = contentfulNode?.featuredContentTagline;
    this.featuredContent = contentfulNode?.featuredContent;
    this.ctaText = contentfulNode?.ctaText;
    this.enabled = contentfulNode?.enabled;
  }
}

export default NavigationSection;
